
/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
 (function () {

  // 変数
  var rul = {}; // ルール
  var msg = {}; // メッセージ
  var glp = {}; // エラーメッセージのグループ設定

  // グローバル変数　※先にjs/validation/common.jsを読み込んでおく
  var getMsg = window.ohValidateGetMsg; // メッセージリスト
  var changeBlank = window.ohValidateChangeBlank; // 空白変換関数
  var changeHankaku = window.ohValidateChangehankaku; // 半角変換関数

  // 名前
  // バリデーション前にvalue変更
  rul['customer_nm'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 40
  };
  msg['customer_nm'] = {
    required:getMsg('required','名前'),
    maxlength:getMsg('max.string', '名前', {'max' : '40'}),
  };

  // ふりがな
  rul['customer_kn'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    kana: true,
    maxlength: 40
  };
  msg['customer_kn'] = {
    required:getMsg('required','ふりがな'),
    kana:getMsg('kana2'),
    maxlength:getMsg('max.string', 'ふりがな', {'max' : '40'})
  };

  // ご希望のご連絡方法（チェックボックスのためバリデーションなし）

  // トリム,空白,半角に自動変換
  // 電話番号
  rul['customer_tel_no'] = {
    required: {
      depends:function(){
        $(this).val($.trim($(this).val()));
        $(this).val(changeBlank($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return true;
      }
    },
    regex: '^(0{1}\\d{1,4}-{0,1}\\d{1,4}-{0,1}\\d{1,4})$',
    maxlength: 13
  };
  msg['customer_tel_no'] = {
    required:getMsg('required','電話番号',),
    regex:getMsg('regex','電話番号'),
    maxlength:getMsg('max.string', '電話番号', {'max' : '13'}),
  };

  // ご希望連絡時間帯（プルダウンのためバリデーションなし）

  // メールアドレス
  // ajaxでバリデートする場合、remoteにURLを指定
  // 現行では全角文字を半角に変換した後にバリデートを掛けているが、その部分をphpコード（validate-email）に追加実装
  rul['customer_email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['customer_email'] = {
    required:getMsg('required','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','メールアドレス'),
  };

  // 郵便番号
  rul['customer_zip_cd'] = {digits: true, maxlength: 7};
  msg['customer_zip_cd'] = {
    digits:getMsg('numeric','郵便番号'),
    maxlength:getMsg('single_bite_digits', '郵便番号',  {'digits' : '7桁の'}),
  };

  // 住所１
  rul['customer_address1'] = {
    maxlength: 40};
  msg['customer_address1'] = {
    maxlength:getMsg('max.string', '住所1', {'max' : '40'}),
  };

  // 住所２
  rul['customer_address2'] = {
    maxlength: 20
  };
  msg['customer_address2'] = {
    maxlength:getMsg('max.string', '住所2', {'max' : '20'}),
  };

  // 相談方法（ラジオボタンのためバリデーションなし）
  // 希望ツール（チェックボックスのためバリデーションなし）
  // 相談希望日1,2（datepickerのためバリデーションなし）
  // 相談希望時1,2（プルダウンのためバリデーションなし）
  // 物件種別（ラジオボタンのためバリデーションなし）

  // 現在ご所有の不動産：マンション名
  rul['property_nm'] = {
    maxlength: 40};
  msg['property_nm'] = {
    maxlength:getMsg('max.string', '現在ご所有の不動産のマンション名', {'max' : '40'}),
  };

  // 現在ご所有の不動産：部屋番号
  rul['property_room_no'] = {
    maxlength: 5
  };
  msg['property_room_no'] = {
    maxlength:getMsg('max.string', '現在ご所有の不動産の部屋番号', {'max' : '5'}),
  };

  // 現在ご所有の不動産：物件住所
  rul['property_address'] = {
    maxlength: 60
  };
  msg['property_address'] = {
    maxlength:getMsg('max.string', '現在ご所有の不動産の物件住所', {'max' : '60'}),
  };

  // 関心の高いこと・ご不明点（チェックボックスのためバリデーションなし）

  // ご質問・ご要望
  rul['consult_txt'] = {
    maxlength: 500};
  msg['consult_txt'] = {
    maxlength:getMsg('max.string', 'ご質問・ご要望', {'max' : '500'}),
  };

  // 個人情報保護方針（プライバシー・ポリシー）
  rul['privacy_policy'] = { required: true};
  msg['privacy_policy'] = { required: getMsg('required','個人情報保護方針（プライバシー・ポリシー）') };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());


/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {
  // お客様情報
  $(".contact_way-group").on('change', function() {
    $("#contact_way1").valid();
  });
}());
